import "./App.css";
import React, { useState, useEffect } from "react";
import Desktop from "./views/Desktop";
import Mobile from "./views/Mobile";

function MainView() {
  
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  // useEffect para detectar si se está redimensionando la ventana
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener("resize", handleWindowSizeChange);

    // Limpiar el evento cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  // Consideramos que es mobile si el ancho o alto son menores a un umbral
  const isMobile = dimensions.width <= 768 || dimensions.height <= 550;

  console.log({dimensions})
  console.log({isMobile})

  return (
    !isMobile ? <Desktop /> :   <Mobile />
  );
}

export default MainView;
